import styled, { keyframes, css } from 'styled-components';

import { ImageSidebarBackground } from '~/assets/images';
import { breakpoints } from '~/styles/tools/breakpoints';

interface SidebarProps {
  visible: boolean;
}

const backgroundAppear = keyframes`
  from {
    opacity: 0;
    transform: translateX(-1rem);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

export const Container = styled.div<SidebarProps>`
  display: none;

  @media (min-width: ${breakpoints.medium}) {
    display: flex;
  }

  flex-direction: column;
  align-items: center;

  position: relative;
  top: 0;
  left: 0;
  z-index: 3;

  max-height: 100vh;
  overflow-y: auto;

  background: url(${ImageSidebarBackground}) 0% 0% no-repeat padding-box #242424;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 1;

  width: 10rem;
  min-width: 10rem;

  transition: 300ms ease-in;

  > header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    width: 100%;
    height: 10rem;

    /* margin-bottom: 2rem; */

    > img {
      height: 5.8rem;
      width: 6.2rem;
      object-fit: contain;
    }

    > h1 {
      display: none;

      color: #fff;
      font-size: 1.8rem;
      margin-left: 1.6rem;
    }
  }

  /* NavLink */
  > a {
    &:nth-child(2) {
      margin-top: 5rem;
    }

    section {
      width: 100%;

      display: grid;
      grid-template-columns: 1fr;
      align-items: center;

      height: 4.6rem;
      padding: 0.5rem 0;

      > svg {
        .a {
          fill: #fff;

          transition: 180ms ease-in-out;
        }
      }

      > p {
        display: none;
        color: #fff;
        margin-left: 1rem;
        font-size: 1.8rem;
        letter-spacing: 0.25rem;
        transition: 180ms ease-in-out;
      }

      :hover {
        > svg {
          .a,
          .b {
            fill: ${({ theme }) => theme.colors.yellow};
            stroke: ${({ theme }) => theme.colors.yellow};
          }
        }

        > p {
          color: ${({ theme }) => theme.colors.yellow};
        }
      }
    }

    &.active {
      > section {
        > svg {
          .a,
          .b {
            fill: ${({ theme }) => theme.colors.yellow};
            stroke: ${({ theme }) => theme.colors.yellow};
          }
        }

        > p {
          color: ${({ theme }) => theme.colors.yellow};
        }
      }
    }
  }

  > button {
    display: flex;
    align-items: center;
    position: absolute;

    background: linear-gradient(115deg, #ffdf22 0%, #ffd503 100%) 0% 0%
      no-repeat padding-box;

    width: 100%;
    height: 5rem;

    padding-left: 2rem;

    transition: 300ms ease-in;

    top: 10rem;

    cursor: auto;

    > svg {
      display: none;
      .a {
        fill: #000;
      }
    }

    > p {
      display: none;

      font-weight: 700;
      font-size: 1.8rem;
      letter-spacing: 0.25rem;

      margin-left: 1.2rem;
    }
  }

  ${({ visible }) =>
    visible &&
    css`
      width: 27.3rem;
      min-width: 27.3rem;

      > header {
        > img {
        }

        > h1 {
          display: flex;
        }
      }

      > a {
        width: 100%;

        &:nth-child(2) {
          margin-top: 0rem;
        }

        section {
          grid-template-columns: 1fr 7fr;
          padding-left: 5%;

          > svg {
            .a {
              fill: #fff;
            }
          }

          > p {
            display: flex;
            color: #fff;
          }
        }

        &.active {
          > section {
            background: #ffdf22;

            animation: ${backgroundAppear} 500ms;
            > svg {
              .a {
                fill: #000;
              }
            }

            > p {
              color: #000;
            }
          }
        }
      }
    `}
`;
